import { SHIPPING_REGION_LABELS } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { ShippingEstimateLine } from '@/entities/quote';
import { formatKrw } from '@/shared/lib';

export interface EstimateShippingBreakdownProps {
  /** 카드 순서대로 배송지별 배송비. */
  readonly lines: readonly ShippingEstimateLine[];
}

/**
 * 임시 견적의 배송지별 배송비(spec §6-1 "펼치면 배송지별") — 네이티브 `<details>` 라 키보드·낭독기 기본 지원, 상태 없음.
 * 주소를 아직 고르지 않은 배송지는 '주소 미정'(기본 배송비)으로 보인다.
 */
export const EstimateShippingBreakdown = ({
  lines,
}: EstimateShippingBreakdownProps): ReactElement => (
  <details className="text-xs">
    <summary className="cursor-pointer text-muted-foreground underline-offset-4 hover:underline">
      배송지별 배송비
    </summary>
    <ul aria-label="배송지별 배송비" className="mt-2 flex flex-col gap-1">
      {lines.map((line, index) => (
        <li
          // biome-ignore lint/suspicious/noArrayIndexKey: 위치가 곧 의미인 읽기 전용 목록(배송지 N)
          key={index}
          className="flex justify-between gap-4 tabular-nums"
        >
          <span>
            배송지 {index + 1} ·{' '}
            {line.region === null ? '주소 미정' : SHIPPING_REGION_LABELS[line.region]}
          </span>
          <span>{formatKrw(line.fee)}</span>
        </li>
      ))}
    </ul>
  </details>
);
